export const texts = {
  bookshopLink: 'https://ksiegarnia.gwo.pl/product/edugry-20',
  description: `Dodaj do koszyka przynajmniej trzy eduGry,<br/>a na każdą z nich
          naliczy Ci się <b>rabat 20%</b>.`,
  title: 'W pakiecie taniej!',
};
